import { ReactNode } from 'react';
import styles from './ToggleListWrapper.module.scss';

const ToggleListWrapper = ({ children, ...props }: { children: ReactNode }) => {
    return (
        <div className={styles.toggleListWrapper} {...props}>
            {children}
        </div>
    );
};

export default ToggleListWrapper;
